import { Modal, Typography } from "antd";

function ClosingTaskModal({
	open,
	setOpen,
	handleOk,
}: {
	open: boolean;
	setOpen: (open: boolean) => void;
	handleOk: () => void;
}) {
	return (
		<Modal
			open={open}
			closable={false}
			width={"40%"}
			title="Close task?"
			centered
			destroyOnClose
			okText={"Close task"}
			onCancel={() => setOpen(false)}
			onOk={handleOk}
		>
			<Typography.Text>
				Closing this task will update its status to "Closed". You may still
				reopen the task if needed. Do you wish to proceed?
			</Typography.Text>
		</Modal>
	);
}

export default ClosingTaskModal;
